import { Injectable } from '@angular/core';

import {
  GovernTenantCategoryDto,
  GovernTenantCategoryFormDto,
  FindGovernTenantCategoryDto,
} from '../../dto/governance-admin/tenant-category.dto';
import { PageResultDto } from '../../dto';
import { HttpService } from '../http.service';
import { ADMIN_API_ENDPOINTS } from '@api/common/api-endpoints';

@Injectable()
export class FnbProductCategoryApiService {
  private get endpoint(): string {
    return ADMIN_API_ENDPOINTS.FNB_PRODUCT_CATEGORY;
  }

  constructor(private httpService: HttpService) {}

  async find(
    params?: FindGovernTenantCategoryDto
  ): Promise<PageResultDto<GovernTenantCategoryDto>> {
    return await this.httpService.get<PageResultDto<GovernTenantCategoryDto>>(
      this.endpoint,
      params
    );
  }

  async create(
    dto: GovernTenantCategoryFormDto
  ): Promise<GovernTenantCategoryDto> {
    return await this.httpService.post<GovernTenantCategoryDto>(
      this.endpoint,
      dto
    );
  }

  async findOne(id: string): Promise<GovernTenantCategoryDto> {
    return await this.httpService.get<GovernTenantCategoryDto>(
      `${this.endpoint}/${id}`
    );
  }

  async update(
    id: string,
    dto: GovernTenantCategoryFormDto
  ): Promise<boolean> {
    return await this.httpService.put<boolean>(`${this.endpoint}/${id}`, dto);
  }

  async delete(id: string): Promise<boolean> {
    return await this.httpService.delete<boolean>(`${this.endpoint}/${id}`);
  }
}
